/**
 * PerfIncomeKpiItemTile.mask.ts
 *
 * Data-masking logic for PerfIncomeKpiItemTile.
 * When showData is false, formattedValue fields are replaced with "--"
 * and volumeByCountry entries are masked so no real data is visible.
 */

import type { KpiVolumeByCountry, PerfIncomeKpiItemProps } from "./PerfIncomeKpiItemTile";

const MASKED_VALUE = "--";

export const maskPerfIncomeKpiItemData = (props: PerfIncomeKpiItemProps, showData: boolean): PerfIncomeKpiItemProps => {
  if (showData) return props;

  const maskedVolumeByCountry: KpiVolumeByCountry | undefined = props.volumeByCountry
    ? Object.fromEntries(
        Object.entries(props.volumeByCountry).map(([code, entry]) => [
          code,
          { ...entry, formattedValue: MASKED_VALUE },
        ]),
      )
    : undefined;

  return {
    ...props,
    formattedValue: MASKED_VALUE,
    volumeByCountry: maskedVolumeByCountry,
    isMet: undefined,
  };
};
